import { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { hotVideos } from '@/mocks/zh/home';

export default function HotVideoStream() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const checkScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 10);
    setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth - 10);
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    checkScroll();
    el.addEventListener('scroll', checkScroll, { passive: true });
    return () => el.removeEventListener('scroll', checkScroll);
  }, []);

  const scroll = (direction: 'left' | 'right') => {
    const el = scrollRef.current;
    if (!el) return;
    const amount = 340;
    el.scrollBy({ left: direction === 'left' ? -amount : amount, behavior: 'smooth' });
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            🔥 最新猛料
          </h2>
          <Link
            to="/category/remen"
            className="flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="relative">
          {canScrollLeft && (
            <button
              onClick={() => scroll('left')}
              className="absolute left-0 top-1/2 -translate-y-1/2 z-10 w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50 border border-background-300 text-foreground-700 hover:text-foreground-950 hover:border-foreground-300 transition-all cursor-pointer"
              aria-label="向左滚动"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
          )}
          {canScrollRight && (
            <button
              onClick={() => scroll('right')}
              className="absolute right-0 top-1/2 -translate-y-1/2 z-10 w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50 border border-background-300 text-foreground-700 hover:text-foreground-950 hover:border-foreground-300 transition-all cursor-pointer"
              aria-label="向右滚动"
            >
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          )}

          <div
            ref={scrollRef}
            className="flex gap-5 overflow-x-auto scrollbar-hide pb-4"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {hotVideos.map((video, idx) => (
              <Link
                key={video.id}
                to={`/article/${video.slug}`}
                className="flex-shrink-0 w-[280px] md:w-[320px] group cursor-pointer"
              >
                <div className="relative rounded-xl overflow-hidden bg-background-100">
                  <div className="aspect-[4/3] relative overflow-hidden">
                    <img
                      src={video.cover}
                      alt={video.title}
                      title={`${video.title} - 吃瓜视频`}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      loading={idx < 2 ? 'eager' : 'lazy'}
                    />
                    {video.tag && (
                      <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-500/90 text-white text-xs font-medium whitespace-nowrap">
                        {video.tag}
                      </span>
                    )}
                    <div className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-black/60 text-white text-xs whitespace-nowrap">
                      {video.views} 次播放
                    </div>
                  </div>
                </div>
                <div className="mt-3 px-1">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                    {video.title}
                  </h3>
                  <div className="flex items-center justify-between mt-2 text-xs text-foreground-500">
                    <span>{video.author}</span>
                    <span>{video.updateTime}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}